export default __webpack_public_path__ + "static/media/energyAirFlowLeftActive.3c134765.svg";